import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import "./SettingAccount.css";

const SettingAccount = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [fullName, setFullName] = useState("Abraham Benjamin");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [discordServerLink, setDiscordServerLink] = useState("");
  const [showCountry, setShowCountry] = useState(false);
  const [saveChangesFullName, setSaveChangesFullName] = useState(false);
  const [saveChangesEmail, setSaveChangesEmail] = useState(false);
  const [saveChangesUsername, setSaveChangesUsername] = useState(false);
  const [saveChangesPhoneNumber, setSaveChangesPhoneNumber] = useState(false);
  const [saveChangesCountry, setSaveChangesCountry] = useState(false);
  const [saveChangesDiscordServerLink, setSaveChangesDiscordServerLink] =
    useState(false);
  const [active, setActive] = useState("");
  const [editBiodata, setEditBiodata] = useState(false);
  const [country, setCountry] = useState("Country");
  const [dataCountries, setDataCountries] = useState([]);
  const chooseDropdown = (e) => {
    setCountry(e.target.value);
    setShowCountry((showCountry) => !showCountry);
    setSaveChangesCountry(true);
  };

  const searchCountry = (e) => {
    const items = document.querySelectorAll(
      ".settingAccount__profileInputContainer .dropdown-item-container label"
    );
    const inputValue = e.target.value.toUpperCase();
    items.forEach((item, i) => {
      if (i !== 0) {
        let txtValue = item.textContent || item.innerText;
        if (txtValue.toUpperCase().indexOf(inputValue) > -1) {
          item.style.display = "";
        } else {
          item.style.display = "none";
        }
      }
    });
  };

  const handleSave = (e) => {
    setActive(e.target.id);
  };

  useEffect(() => {
    if (saveChangesFullName) {
      setTimeout(() => {
        setSaveChangesFullName(false);
      }, 1000);
    }

    if (saveChangesPhoneNumber) {
      setTimeout(() => {
        setSaveChangesPhoneNumber(false);
      }, 1000);
    }

    if (saveChangesEmail) {
      setTimeout(() => {
        setSaveChangesEmail(false);
      }, 1000);
    }

    if (saveChangesCountry) {
      setTimeout(() => {
        setSaveChangesCountry(false);
      }, 1000);
    }
    if (saveChangesUsername) {
      setTimeout(() => {
        setSaveChangesUsername(false);
      }, 1000);
    }
    if (saveChangesDiscordServerLink) {
      setTimeout(() => {
        setSaveChangesDiscordServerLink(false);
      }, 1000);
    }

    window.onclick = (e) => {
      if (active === "full-name") {
        if (e.target.closest("#full-name") === null) {
          setSaveChangesFullName(true);
          setActive("");
        }
      }
      if (active === "email") {
        if (e.target.closest("#email") === null) {
          setSaveChangesEmail(true);
          setActive("");
        }
      }
      if (active === "phone-number") {
        if (e.target.closest("#phone-number") === null) {
          setSaveChangesPhoneNumber(true);
          setActive("");
        }
      }
      if (active === "username") {
        if (e.target.closest("#username") === null) {
          setSaveChangesUsername(true);
          setActive("");
        }
      }
      if (e.target.closest("#setting-country") === null) {
        setShowCountry(false);
      }

      if (active === "discord-server-link") {
        if (e.target.closest("#discord-server-link") === null) {
          setSaveChangesDiscordServerLink(true);
          setActive("");
        }
      }
    };

    async function fetchData() {
      const request = await axios.get("https://restcountries.eu/rest/v2/all");
      setDataCountries(request.data);
      console.log(request.data);
    }

    fetchData();
  }, [
    saveChangesFullName,
    saveChangesEmail,
    active,
    saveChangesDiscordServerLink,
    saveChangesUsername,
    saveChangesCountry,
    saveChangesPhoneNumber,
  ]);
  return (
    <div className="settingAccount">
      <form className="settingAccount__formContainer">
        <div className="settingAccount__profileInputSections flex-row">
          <div className="settingAccount__profileInputContainer flex-column">
            <label htmlFor="full-name">Full Name</label>
            <input
              type="text"
              id="full-name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              onClick={handleSave}
              placeholder="Enter your full name"
            />
            {saveChangesFullName && (
              <small className="settinAccount__changes">Change saved</small>
            )}
          </div>
          <div className="settingAccount__profileInputContainer flex-column">
            <label htmlFor="email">Email</label>
            <input
              type="text"
              id="email"
              placeholder="Enter your email"
              value={email}
              onClick={handleSave}
              onChange={(e) => setEmail(e.target.value)}
            />
            {saveChangesEmail && (
              <small className="settinAccount__changes">Change saved</small>
            )}
          </div>
        </div>

        <div
          className="settingAccount__profileInputSections flex-row"
          id="setting-country"
        >
          <div className="settingAccount__profileInputContainer flex-column">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              placeholder="Enter your username"
              value={username}
              onClick={handleSave}
              onChange={(e) => setUsername(e.target.value)}
            />
            {saveChangesUsername && (
              <small className="settinAccount__changes">Change saved</small>
            )}
          </div>
          <div className="settingAccount__profileInputContainer flex-column">
            <label htmlFor="first-name">Country </label>
            <div
              className={`dropdown-container flex-row ${
                showCountry && "expand"
              }`}
              onClick={() => setShowCountry((showCountry) => !showCountry)}
            >
              <p>{country}</p>
              <svg
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 4L8 12L16 20"
                  stroke="black"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div
              className={`dropdown-item-container flex-column ${
                showCountry && "expand"
              }`}
            >
              <label className="settingAccount__profileInputSearch flex-row">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    r="6.2"
                    transform="matrix(-0.819152 0.573576 0.573576 0.819152 13.4948 12.4952)"
                    stroke="#818E94"
                    strokeWidth="2"
                  />
                  <rect
                    width="2"
                    height="7.13287"
                    rx="1"
                    transform="matrix(-0.819152 0.573576 0.573576 0.819152 17.6426 16.6729)"
                    fill="#818E94"
                  />
                </svg>
                <input
                  type="text"
                  placeholder="Search your country"
                  onChange={searchCountry}
                />
              </label>
              {dataCountries.map((countries) => (
                <label
                  htmlFor={countries.alpha2Code}
                  key={countries.alpha2Code}
                >
                  <input
                    type="radio"
                    name="country"
                    id={countries.alpha2Code}
                    value={countries.name}
                    onChange={chooseDropdown}
                  />
                  {countries.name}
                </label>
              ))}
            </div>
            {saveChangesCountry && (
              <small className="settinAccount__changes">Change saved</small>
            )}
          </div>
        </div>
        <div className="settingAccount__profileInputSections flex-row">
          <div className="settingAccount__profileInputContainer flex-column">
            <label htmlFor="phone-number">Phone Number</label>
            <input
              type="text"
              id="phone-number"
              onClick={handleSave}
              onChange={(e) =>
                setPhoneNumber(
                  e.target.value
                    .replace(/[^0-9.]/g, "")
                    .replace(/(\..*?)\..*/g, "$1")
                )
              }
              value={phoneNumber}
              placeholder="Enter your phone number"
            />
            {saveChangesPhoneNumber && (
              <small className="settinAccount__changes">Change saved</small>
            )}
          </div>
          <div className="settingAccount__profileInputContainer flex-column">
            <label htmlFor="discord-server-link">Discord Server Link</label>
            <input
              type="text"
              id="discord-server-link"
              onClick={handleSave}
              onChange={(e) => setDiscordServerLink(e.target.value)}
              value={discordServerLink}
              placeholder="Invitation Link (Make sure it is set to never expire)"
            />
            {saveChangesDiscordServerLink && (
              <small className="settinAccount__changes">Change saved</small>
            )}
          </div>
        </div>

        {/* <button className="settingAccount__btnUpdate btn primary">
          Update
        </button> */}
      </form>
      <div className="settingAccount__bio">
        <div className="flex-row">
          <label htmlFor="setting-bio">Biodata</label>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            onClick={() => setEditBiodata(true)}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.41999 20.579C4.13948 20.5785 3.87206 20.4602 3.68299 20.253C3.49044 20.0475 3.39476 19.7695 3.41999 19.489L3.66499 16.795L14.983 5.481L18.52 9.017L7.20499 20.33L4.51099 20.575C4.47999 20.578 4.44899 20.579 4.41999 20.579ZM19.226 8.31L15.69 4.774L17.811 2.653C17.9986 2.46522 18.2531 2.35971 18.5185 2.35971C18.7839 2.35971 19.0384 2.46522 19.226 2.653L21.347 4.774C21.5348 4.96157 21.6403 5.21609 21.6403 5.4815C21.6403 5.74691 21.5348 6.00143 21.347 6.189L19.227 8.309L19.226 8.31Z"
              fill="#2E3A59"
            />
          </svg>
        </div>
        <p
          id="setting-bio"
          contentEditable={editBiodata}
          className={`${editBiodata && "settingAccount__bioEdit"}`}
        >
          Hi, I’m Abraham Benjamin, Decisions: If you can’t decide, the answer
          is no. If two equally difficult paths, choose the one more painful in
          the short term (pain avoidance is creating an illusion of equality).
        </p>
        {editBiodata && (
          <div className="settingAccount__btnBioContainer flex-row">
            <button className="btn" onClick={() => setEditBiodata(false)}>
              Cancel
            </button>
            <button
              className="btn primary"
              onClick={() => setEditBiodata(false)}
            >
              Save
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SettingAccount;
